import { Route, Routes } from 'react-router-dom';
import './App.scss';
import Home from './containers/Home';
import ComingSoon from './containers/ComingSoon';
import WhoWeAre from './containers/WhoWeAre';
import LifeAtCentrico from './containers/LifeAtCentrico';
import Layout from './containers/Layout';
import Blogs from './containers/Blogs';
import WhatWeDo from './containers/WhatWeDo';
import './i18n';

function App() {
  return (
    <Routes>
      <Route path='/' element={<Layout />}>
        <Route index element={<Home/>}></Route>
        <Route path='/whoweare' element={<WhoWeAre/>}></Route>
        <Route path='/whatwedo' element={<WhatWeDo/>}></Route>
        <Route path='/lifeatcentrico' element={<LifeAtCentrico/>}></Route>
        <Route path='/lifeatcentrico/blogs' element={<Blogs/>}></Route>
        <Route path='*' element={<ComingSoon/>}></Route>
      </Route>
    </Routes>
  );
}

export default App;
